/* eslint-disable @typescript-eslint/no-unsafe-call */
'use client';

import Image from 'next/image';

import { formatDate } from 'mode-shared/utils';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../Dialog';
import { DappHeader } from './DappHeader';
import { getUnixTime } from 'date-fns';
import { ExternalLinkWarning } from '../ExternalLinkWarning';
import { EcosystemDapp, TransformedDapp } from 'mode-shared/hooks/content';

export const DappModal = ({
  isOpen,
  dapp,
  handleClose,
}: {
  isOpen: boolean;
  dapp: TransformedDapp | EcosystemDapp;
  handleClose: () => void;
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent
        aria-describedby="dapp-modal"
        className="md:min-w-[700px] bg-neutral-950 text-white border border-neutral-900"
      >
        <DialogTitle className="hidden" />
        <DialogHeader className="flex items-center bg-neutral-1000 justify-between space-y-0 px-8 py-4  rounded-t-2xl">
          <DappHeader handleClose={handleClose} dapp={dapp} />
        </DialogHeader>
        <DialogDescription className="hidden" />
        <div className="w-full flex flex-col items-center justify-center space-y-8 py-8 px-8">
          <Image
            className="w-full rounded-xl"
            src={dapp?.background || ''}
            width={600}
            height={150}
            alt={`${dapp?.name} banner`}
          />
          <p className="font-sans text-sm text-grey-600 max-w-[386px] text-center">{dapp?.description}</p>
        </div>

        {dapp?.audits && (
          <div className="flex flex-col justify-items-start justify-self-start mb-8 mx-8 gap-4">
            {dapp.audits
              .sort((a, b) => getUnixTime(new Date(b.date)) - getUnixTime(new Date(a.date)))
              .map((audit) => (
                <ExternalLinkWarning
                  href={audit.url}
                  key={`${audit.id}-${audit.date}`}
                  className="flex justify-self-start gap-4 items-center bg-neutral-900 border border-neutral-900 p-4 rounded-lg"
                >
                  <div className="flex items-center gap-2">
                    <div className="font-primary font-medium text-xs text-grey-300 uppercase">Audited by:</div>
                    {audit.logo ? (
                      <Image src={audit.logo} width={60} height={16} alt={`${audit.name} logo`} />
                    ) : (
                      <div className="font-primary text-xs text-neutral-100 uppercase">{audit.name}</div>
                    )}
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="font-primary font-medium text-xs text-grey-300 uppercase">Date:</div>
                    <div className="font-primary text-xs text-neutral-100">{formatDate(audit.date)}</div>
                  </div>
                </ExternalLinkWarning>
              ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
